export default __webpack_public_path__ + "static/media/facebook-card.182fea17.JPG";